import { createContext, useCallback, useContext, useMemo, useState, startTransition } from "react";
import AddToCartConfirmation from "../components/cart/AddToCartConfirmation";
import { itemsToBoxes } from "../helpers/aa-products";

const AddToCartContext = createContext(null);

export function AddToCartProvider({ children }) {
  const [state, setState] = useState(null);

  const showAddedToCart = useCallback((product, quantity) => {
    const boxes = itemsToBoxes(Number(quantity) || 0, product);
    startTransition(() => {
      setState({
        productName: product?.name || "",
        boxes: boxes > 0 ? boxes : 1
      });
    });
  }, []);

  const close = useCallback(() => {
    startTransition(() => setState(null));
  }, []);

  const value = useMemo(
    () => ({
      showAddedToCart,
      close
    }),
    [showAddedToCart, close]
  );

  return (
    <AddToCartContext.Provider value={value}>
      {children}
      <AddToCartConfirmation
        isOpen={Boolean(state)}
        productName={state?.productName}
        boxes={state?.boxes}
        onClose={close}
        onContinue={close}
      />
    </AddToCartContext.Provider>
  );
}

export function useAddToCartConfirmation() {
  const ctx = useContext(AddToCartContext);
  if (!ctx) {
    throw new Error("useAddToCartConfirmation must be used within AddToCartProvider");
  }
  return ctx;
}
